const BASE_URL = 'https://accordi-web-eqb2byhxd0feffhu.norwayeast-01.azurewebsites.net/api/';

export default class CallController {
  // Category
  static GetAllCategories = `${BASE_URL}category/GetAllCategoriesAsync`;
  static AddCategory = `${BASE_URL}category/AddCategoryAsync`;
  static DeleteCategory = `${BASE_URL}category/DeleteCategoryAsync`;

  // Product
  static GetAllProducts = `${BASE_URL}product/GetAllProductsAsync`;
  static GetProductsByCategory = (categoryId: number) => 
 `${BASE_URL}product/GetAllProductsByCategoryAsync/${categoryId}`;
  static AddProduct = `${BASE_URL}product/AddProductAsync`;
  static GetProductById = (productId: number) => 
    `${BASE_URL}product/${productId}`; 
  static DeleteProductById = (productId: number) => 
    `${BASE_URL}product/DeleteProductAsync/${productId}`;
  static UpdateProduct = (productId: number) => `${BASE_URL}product/UpdateProductAsync/${productId}`;
  static GetProductsWithActiveCampaignsByCategoryAsync = (categoryId: number) =>
    `${BASE_URL}Product/GetProductsWithActiveCampaignsByCategoryAsync/${categoryId}`;
  static GetProductWithActiveCampaignById = (productId: number) =>
    `${BASE_URL}product/GetProductWithActiveCampaignByIdAsync/${productId}`;


  // AdminProduct 
  static AddProductWithImage = `${BASE_URL}admin/product/AddProductWithImage`;

  // Campaign
  static GetAllCampaigns = `${BASE_URL}campaign/GetAllCampaignsAsync`;
  static DeleteCampaignById = (id: number) => `${BASE_URL}campaign/DeleteCampaignAsync/${id}`;
  static AddCampaign = `${BASE_URL}campaign/AddCampaignAsync`;
  static UpdateCampaign = (id: number) => `${BASE_URL}campaign/UpdateCampaignAsync/${id}`;
  static GetCampaignById = (id: number) => `${BASE_URL}campaign/GetCampaignByIdAsync/${id}`;

}
